import { evaluateResponseErrorCode, getApiError } from '../../errors';
import { post } from '../../http';

export type ResetPasswordRequest = {
  stateToken: string;
  newPassword: string;
};
export const updatePasswordRequest = async (requestBody: ResetPasswordRequest) => {
  try {
    const result = await post('/guest/updatePassword', {
      body: JSON.stringify(requestBody),
    });

    evaluateResponseErrorCode(result.response);

    return result.response;
  } catch (error) {
    throw getApiError(error);
  }
};
